import React from "react";
import styled from "styled-components";
import { Button } from "./button/Button";
import { Flex } from "./compositeComponents/FlexHelpers";
import { Modal } from "./Modal";


export function ThumbnailImageGallery(props:{
    files:{
        privateFileName:string, 
        publicFileName:string
    }[],
    onDelete?: (privateFileName:string) => void
}):JSX.Element
{
    
    const [selectedFile, setSelectedFile] = React.useState<{privateFileName:string, publicFileName:string} | null>(null);

    return (
        <>
            <Flex style={{ flexWrap:'wrap', justifyContent:'flex-start', gap:54 }}>
                {props.files.map(f =>
                    <Flex key={f.privateFileName} flexDirection='column'>
                        <StyledThumbnail src={`/files/${f.privateFileName}?thumbnail`}
                            onClick={() => setSelectedFile({...f})} />

                        <div style={{textAlign:'center', fontSize:'12px', width:'200px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                            {f.publicFileName}
                        </div>
                    </Flex>
                )}
            </Flex>

            <ImageModal 
                show={selectedFile !== null} 
                publicFileName={selectedFile?.publicFileName || ''} href={`/files/${selectedFile?.privateFileName || ''}`}
                onClose={() => setSelectedFile(null)} 
                onDelete={() => {
                    if(props.onDelete && selectedFile)
                    {           
                        props.onDelete(selectedFile.privateFileName);
                        setSelectedFile(null);
                    }
                }}
            />
        </>
    );
}



const StyledThumbnail = styled.img`
    width:200px;
    height:200px;
    object-fit:cover;
    cursor:pointer;
`;

type ImageModalProps = {
    show:boolean
    publicFileName:string,
    href:string,
    onDelete?:()=>void,
    onClose:()=>void
}
function ImageModal(props:ImageModalProps):JSX.Element
{
    return (
        <Modal 
            title={props.publicFileName} 
            showModal={props.show}
            onCancel={props.onClose}
            content={
                <>
                    <div>
                        <Flex flexDirection="column" alignItems='center' gap={8}>
                            <Flex justifyContent='flex-end' style={{width:'100%'}}>
                                {props.onDelete &&
                                    <Button variant={'destructive'}  text="Slet" onClick={props.onDelete} />
                                }
                            </Flex>
                            <div style={{minHeight:'40vh', maxWidth:'90%', maxHeight:'100%', textAlign:'center'}}>
                                <img src={props.href} style={{width:'90%'}} />
                            </div>
                        </Flex>
                    </div>
                </>
            }
        />
    );
}